import {
	GET_ALL_RELATED_DOCUMENTS_FOR_SAMPLE,
	RELATE_SAMPLE_ITEM_DOCUMENT,
	DELETE_DOCUMENT_FROM_SAMPLE_ITEM,
	CLEAR_SAMPLE_RELATED_DOCUMENTS
} from '../actiontypes';
import env from '../../util/env';
import {serviceURL, documentSearchTypes} from '../../util/uiconstants';
import {isEmpty} from 'lodash';
import {createApiCreateAction, createApiDeleteAction, API_RESOURCES} from '../../util/api';

export const getRelatedDocumentsForSample = (
	engagementId,
	entityId,
	pageSize,
	currentPage = 1,
	documentCategoryName,
	parentName,
	searchText
) => {
	let url =
		env.getBaseURL(serviceURL, engagementId) +
		`documents` +
		`?filteredEntityType=${documentSearchTypes.sampleItem}` +
		`&documentCategoryName=${documentCategoryName}` +
		`&filteredEntityIdInt=${entityId}` +
		`&includeApprovals=${true}` +
		`&includeReviewNotes=${true}` +
		`&pageSize=${pageSize}` +
		`&page=${currentPage}`;

	if (!isEmpty(searchText)) url += `&searchString=${searchText}`;

	return {
		type: GET_ALL_RELATED_DOCUMENTS_FOR_SAMPLE,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		},
		parentName: parentName ? parentName : documentCategoryName
	};
};

export const clearRelatedDocuments = () => {
	return {
		type: CLEAR_SAMPLE_RELATED_DOCUMENTS
	};
};

export const removeDocumentFromSampleItem = (
	engagementId,
	sampleListId,
	sampleItemId,
	documentId,
	parentName,
	queryParams
) => {
	return createApiDeleteAction(
		DELETE_DOCUMENT_FROM_SAMPLE_ITEM,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.SAMPLELISTS]: sampleListId,
			[API_RESOURCES.SAMPLEITEMS]: sampleItemId,
			[API_RESOURCES.DOCUMENTS]: documentId
		},
		{documentId: documentId, parentName: parentName},
		true,
		undefined,
		queryParams
	);
};

export const relateSampleItemDocument = (engagementId, sampleListId, sampleItemId, parentName, payload) => {
	return createApiCreateAction(
		RELATE_SAMPLE_ITEM_DOCUMENT,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.SAMPLELISTS]: sampleListId,
			[API_RESOURCES.SAMPLEITEMS]: sampleItemId,
			[API_RESOURCES.DOCUMENTS]: undefined
		},
		payload,
		{parentName: parentName}
	);
};
